import { useContext } from "react";
import Context from "../../../common/components/utils/context";

export const AdminFormsStructure = () => {
  const context = useContext(Context);

  return (
    <div className="container mb-auto relative">
      <iframe
        title="Company Structure"
        src={`https://foundat-62677.bubbleapps.io/dashboard/company_structure?user_id=${context.cryptedUserID}&company_id=${context.cryptedCompanyID}&role_id=${context.cryptedRole}`}
        className="w-full h-screen"
      />
    </div>
  );
};
